<template>
    <div>
        <div
            class="col-12 p-0 col-md-4"
            :class="showChat ? 'col-md-4' : 'col-md-8'"
        >
            <Chat
                :chat="chat"
                :account="token"
                :templates="templates.external"
                :answers="templates.internal"
                v-if="selectedChat"
            />
        </div>

        <div class="route-step-indicator mb-2 fs-5">
            <div class="route-step-descrip text-center text-primary fw-bold">
                <span v-if="step == '1'">Paso 1: Selecciona Ruta</span>
                <span v-if="step == '2'"
                    >Paso 2: Inscribe Usuarios a la ruta:
                    {{ this.updateClient.name }}</span
                >
                <span v-if="step == '3'">Paso 3: Confirma tu inscripción</span>
            </div>

            <div
                id="route-step-dot"
                class="d-flex justify-content-center route-step-dot fs-4 my-2"
            >
                <i
                    class="fa-solid fa-chevron-left text-primary me-3"
                    type="button"
                    @click="lessStep()"
                ></i>

                <div class="step-dot dot-1 active"></div>
                <div
                    class="step-dot dot-2"
                    :class="step == '2' || step == '3' ? 'active' : ''"
                ></div>
                <div
                    class="step-dot dot-3"
                    :class="step == '3' ? 'active' : ''"
                ></div>

                <i
                    class="fa-solid fa-chevron-right text-primary ms-3"
                    type="button"
                    @click="plusStep()"
                ></i>
            </div>
        </div>

        <!---------- PASO 1 ---------->
        <div class="route-step-one" :class="step != '1' ? 'd-none' : ''">
            <div class="form-group col-lg-4 p-0">
                <label for="route-name" class="form-label fw-bold text-dark"
                    >Nombre de la ruta</label
                >
                <input
                    type="text"
                    v-model="updateClient.name"
                    class="form-control border-dark"
                    placeholder="Nombre de la ruta de aprendizaje"
                    aria-label="Nombre de la ruta de aprendizaje"
                />
            </div>

            <div class="form-group mt-4">
                <label
                    for="route-description"
                    class="form-label fw-bold text-dark"
                    >Agrega una descripción</label
                >
                <textarea
                    class="form-control border-dark"
                    v-model="updateClient.description"
                    rows="3"
                ></textarea>
            </div>

            <div class="row mt-4">
                <div class="col-lg-8">
                    <div class="row">
                        <div class="col-lg-4">
                            <select
                                name="cat-filter"
                                id="cat-filter"
                                class="form-control px-3 border-dark"
                                v-model="catSelected"
                            >
                                <option value="">
                                    Seleccione una categoría
                                </option>
                                <optgroup
                                    v-for="(cat, index) of categories.children"
                                    :key="index"
                                    :label="cat.name"
                                >
                                    <option
                                        v-for="(catc, i) of cat.children"
                                        :key="'child' + i"
                                        :value="catc.term_id"
                                    >
                                        {{ catc.name }}
                                    </option>
                                </optgroup>
                            </select>
                        </div>
                        <div class="col-lg-4">
                            <input
                                type="text"
                                name="name-filter"
                                v-model="courseName"
                                id="name-filter"
                                class="form-control px-3 border-dark"
                                placeholder="Nombre del curso"
                            />
                        </div>
                        <div class="col-lg-4">
                            <button
                                class="btn btn-utel w-100"
                                @click="filterDataCourse"
                            >
                                Filtrar cursos
                            </button>
                        </div>
                    </div>

                    <div class="my-3">
                        Busca en toda nuestra ofertas de cursos
                    </div>

                    <div class="row maxheight100vh">
                        <div class="col-md-4" v-for="item in dessertsCourse">
                            <div class="card rounded-8 overflow-hidden shadow">
                                <div class="carg-img">
                                    <img
                                        :src="item.image"
                                        alt=""
                                        class="img-fluid object-fit-cover w-100"
                                        style="max-height: 87px"
                                    />
                                </div>
                                <div
                                    class="card-body lh-sm text-dark pt-2 pb-0"
                                >
                                    <div class="text-primary mb-1">
                                        <i
                                            class="fa-solid fa-user text-secondary"
                                        ></i>
                                        {{ item.count_students }}
                                    </div>

                                    <div
                                        class="fw-bold small lh-sm mb-0 pb-0"
                                        style="min-height: 45px"
                                    >
                                        {{ item.name }}
                                    </div>

                                    <p class="card-text small">{{ strippedContent(item.content).length>=135 ? strippedContent(item.content).substring(0,135)+"..." : strippedContent(item.content) }}</p>
                                </div>

                                <div
                                    class="card-footer border-0 text-center mb-3"
                                >
                                    <!-- <a type="button" class="card-link bg-primary text-light fw-bold rounded-8 w-auto py-2 px-4"
                                    data-bs-toggle="modal" data-bs-target="#confirmarInscribir">Agregar curso <i class="fa-solid fa-plus ms-1"></i></a> -->
                                    <!-- <a type="button" class="">Agregar curso <i class="fa-solid fa-plus ms-1"></i></a> -->
                                    <div
                                        class="card-link bg-primary text-light fw-bold rounded-8 w-auto py-2 px-4"
                                        type="button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#addModal"
                                        @click="
                                            addCourseItems(
                                                item.image,
                                                item.name,
                                                item.id,
                                                item.slug,
                                                item
                                            )
                                        "
                                    >
                                        Agregar curso
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center" v-if="mostrarPaginasCourses" style="margin-bottom: 10px; margin-top: 30px">
                        <div style="display:inline-block" v-if="paginaActualCourses - 2 > 0">
                            <button class="btn btn-utelx" @click.prevent="getCoursesByPage(1)"><i class="fa-solid fa-angles-left"></i></button>
                        </div>
                        <div style="display:inline-block; margin-left: 10px" v-if="paginaActualCourses > 1">
                            <button class="btn btn-utelx" @click.prevent="getCoursesByPage(paginaActualCourses-1)"><i class="fa-solid fa-angle-left"></i></button>
                        </div>
                        <div style="display:inline-block; margin-left: 10px">
                            <button class="btn btn-primary" @click.prevent="getCoursesByPage(paginaActualCourses)">{{ paginaActualCourses }}</button>
                        </div>
                        <div style="display:inline-block; margin-left: 10px" v-if="ultimaPaginaCourses == -1 || paginaActualCourses < ultimaPaginaCourses">
                            <button class="btn btn-utelx" @click.prevent="getCoursesByPage(paginaActualCourses+1)"><i class="fa-solid fa-angle-right"></i></button>
                        </div>
                        <div style="display:inline-block; margin-left: 10px" v-if="ultimaPaginaCourses != -1 && ultimaPaginaCourses >= paginaActualCourses + 2">
                            <button class="btn btn-utelx" @click.prevent="getCoursesByPage(ultimaPaginaCourses)"><i class="fa-solid fa-angles-right"></i></button>
                        </div>
                    </div>

                </div>

                <!-- modal selection -->

                <div
                    class="modal fade"
                    id="addModal"
                    tabindex="-1"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    aria-labelledby="addModalLabel"
                    aria-hidden="true"
                >
                    <div
                        class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
                    >
                        <div class="modal-content">
                            <div class="modal-header text-center">
                                <button
                                    type="button"
                                    class="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div class="modal-body text-center p-5 pt-2">
                                <!-- Sección listado Cursos INICIO -->
                                <div
                                    id="listadoCursosPaquetes"
                                    class="d-none mt-4 mb-4"
                                >
                                    <div
                                        v-if="listcourses"
                                        class="mt-3 mb-3"
                                        id="ocultarData"
                                    >
                                        <div class="alert alert-primary small">
                                            <b>Atención: </b>
                                            Para poder continuar, debes agregar
                                            estos cursos.
                                        </div>
                                        <div
                                            class="course border-bottom border-gray row align-items-center py-2"
                                            v-for="(item, index) in listcourses"
                                            :index="index"
                                            :key="item.test"
                                        >
                                            <div
                                                class="course-info col-12 pe-0"
                                            >
                                                <div
                                                    class="row align-items-center"
                                                >
                                                    <div
                                                        class="col-4 course-img p-1"
                                                    >
                                                        <img
                                                            :src="item.image"
                                                            alt=""
                                                            class="img-fluid rounded-3"
                                                        />
                                                    </div>
                                                    <div class="col-8 p-1">
                                                        <div
                                                            class="course-description lh-1"
                                                        >
                                                            {{ item.name }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <h3>¿Deseas continuar?</h3>
                                            <div class="btn-group">
                                                <button
                                                    v-on:click="
                                                        seen_two = !seen_two
                                                    "
                                                    id="yes_button"
                                                    type="button"
                                                    class="btn btn-utel btn-inverted me-3"
                                                    @click="aceptarProceso()"
                                                >
                                                    Si
                                                </button>
                                                <button
                                                    @click="cancelarProceso()"
                                                    id="no_button"
                                                    type="button"
                                                    class="btn btn-utel text-light px-4"
                                                    data-bs-dismiss="modal"
                                                >
                                                    No
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Sección listado Cursos FIN -->
                                <div class="d-block" id="cirle-content">
                                    <div class="circle-loading"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 maxheight100vh">
                    <div
                        class="bg-bluegray rounded-8 px-4"
                        style="min-height: 65px"
                    >
                        <!-- <div>
                        {{ selectedCourse ? '' : "No ha seleccionado ningun curso" }}
                    </div> -->

                        <div
                            class="course border-bottom border-gray row align-items-center py-2"
                            v-for="(item, index) in selectedCourse"
                            :index="index"
                            :key="item.test"
                        >
                            <div class="course-ids col-2">
                                <div class="course-id">
                                    {{ index + 1 }}
                                </div>
                            </div>
                            <div class="course-info col-8 pe-0">
                                <div class="row align-items-center">
                                    <div class="col-4 course-img p-1">
                                        <img
                                            :src="item.image"
                                            alt=""
                                            class="img-fluid rounded-3"
                                        />
                                    </div>
                                    <div class="col-8 p-1">
                                        <div class="course-description lh-1">
                                            {{ item.name }}
                                        </div>
                                        <!-- <div class="float-end text-primary">
                                        <i class="fa-solid fa-star"></i> 4.5
                                    </div> -->
                                    </div>
                                </div>
                            </div>
                            <div
                                class="course-remove text-end col-2"
                                v-if="item.borrado"
                            >
                                <i
                                    class="fa-regular fa-trash-can text-primary fs-3"
                                    @click="trashCourse(index)"
                                ></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-5 text-end">
                <a
                    type="button"
                    class="fw-bold rounded-8 w-auto py-2 px-4 border-primary border me-3"
                    @click="pasarStep(3)"
                    >Guardar ruta</a
                >
                <a
                    type="button"
                    class="card-link bg-primary text-light fw-bold rounded-8 w-auto py-2 px-4"
                    data-bs-toggle="modal"
                    data-bs-target="#confirmarInscribir"
                    >Continuar inscribiendo Usuarios</a
                >
            </div>
        </div>

        <!---------- PASO 2 ---------->
        <div class="route-step-two" :class="step == '2' ? '' : 'd-none'">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-md-5">
                        <p
                            class="border border-dark rounded-8 d-flex align-items-center form-search p-0"
                        >
                            <input
                                type="text"
                                class="form-control border-0 rounded-8"
                                placeholder="Busca tu estudiante"
                                @keyup="filterDataStudent"
                                v-model="StudentName"
                            />
                        </p>
                    </div>
                    <div v-if="empresas.length > 0" class="col-md-5">
                        <div class="form-group">
                            <!-- <label for="empresa">Seleccionar empresa</label> -->
                            <select
                                name="empresa"
                                id="empresa"
                                class="form-control"
                                v-model="empresaSelected"
                                @change="changeUrl"
                            >
                                <option value="">
                                    Seleccionar empresa para la asignación de
                                    Usuarios y ruta
                                </option>
                                <option
                                    v-for="(client, index) of empresas"
                                    :key="index"
                                    :value="client.idClient"
                                >
                                    {{ client.client }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive mb-2">
                <table
                    class="table table-sm text-center align-middle mt-3 small"
                >
                    <thead class="">
                        <tr>
                            <th scope="col">
                                <span class="text-primary fw-bold">
                                    ({{ this.selectedStudents.length }}/{{
                                        this.dessertsStudents
                                            ? this.dessertsStudents.length
                                            : 0
                                    }})
                                </span>
                            </th>
                            <th scope="col">
                                <div class="d-block text-center">Nombres</div>
                            </th>
                            <th scope="col">
                                <div class="d-block text-center">Apellidos</div>
                            </th>
                            <th scope="col">
                                <div class="d-block text-center">Cargo</div>
                            </th>
                            <th scope="col">
                                <div class="d-block text-center">Area</div>
                            </th>
                            <th scope="col">
                                <div class="d-block text-center">
                                    Correo Electronico
                                </div>
                            </th>
                            <th scope="col">
                                <div class="d-block text-center">Rol</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            class="fs-4"
                            v-for="(item, index) of dessertsStudents"
                            :key="index"
                        >
                            <td>
                                <div class="">
                                    <div class="form-check">
                                        <input
                                            v-model="selectedStudents"
                                            class="form-check-input"
                                            type="checkbox"
                                            :value="item.id"
                                            :id="'checkStudent' + item.id"
                                            @click="checkEmpresaSelected"
                                        />
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="student-info m-0 small">
                                    <p class="m-0 small">
                                        {{ item.firstname }}
                                    </p>
                                </div>
                            </td>
                            <td>
                                <div class="student-info m-0 small">
                                    {{ item.lastname }}
                                </div>
                            </td>
                            <td>
                                <div class="student-info m-0 small">
                                    {{ item.position }}
                                </div>
                            </td>
                            <td>
                                <div class="student-info m-0 small">
                                    {{ item.area }}
                                </div>
                            </td>
                            <td>
                                <div
                                    class="student-info student-mail m-0 small"
                                >
                                    <a class="text-primary">{{ item.email }}</a>
                                </div>
                            </td>
                            <td>
                                <div class="student-info m-0 small">
                                    Estudiante
                                </div>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="row mb-3">
                <div class="col-md-7">
                    <div class="pager small justify-content-start">
                        <small>Mostrando 6 resultados de 20</small>

                        <a href="javascript:void(0)">
                            <div class="totop">
                                <i
                                    class="fa fa-chevron-up text-primary"
                                    aria-hidden="true"
                                ></i>
                                Arriba
                            </div>
                        </a>
                        <div class="pager-count">Pagina 1 de 4</div>
                        <a href="javascript:void(0)">
                            <div class="next">
                                <i
                                    class="fa fa-chevron-right text-primary"
                                    aria-hidden="true"
                                ></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-5">
                    <button
                        class="btn btn-primary py-3 px-4 mx-2 w-100 rounded-8 fs-5 fw-bold"
                        data-bs-toggle="modal"
                        data-bs-target="#confirmarInscribir"
                        @click="informacionGeneral"
                    >
                        Inscribir Usuarios a esta ruta
                    </button>
                </div>
            </div>
        </div>

        <!---------- PASO 3 ----------->
        <div class="route-step-three" :class="step == '3' ? '' : 'd-none'">
            <div class="row">
                <div class="col-md-6">
                    <div
                        class="card rounded-8 overflow-hidden bg-bluegray w-75 m-auto"
                    >
                        <h5 class="card-title pt-3 px-3 mb-0 text-dark">
                            Descripción
                            <i
                                class="fa-solid fa-pen-to-square text-primary ms-3"
                                @click.prevent="editStep(1)"
                            ></i>
                        </h5>
                        <div class="card-body lh-sm text-dark">
                            <div class="max-lines-5 mb-2">
                                {{ this.updateClient.description }}
                            </div>
                            <!-- <div class="short-description-diploma">
                            <p></p>
                        </div> -->
                            <div
                                class="d-flex border-bottom border-gray pb-2 mb-3 align-items-center justify-content-between"
                            >
                                <h4 class="text-dark mb-0">Cursos agregados</h4>
                                <div
                                    class="bg-light p-2 fw-bold rounded-2 fs-3"
                                >
                                    {{
                                        this.selectedCourse
                                            ? this.selectedCourse.length
                                            : 0
                                    }}
                                </div>
                                <div class="fs-3 text-primary">
                                    <i
                                        class="fa-regular fa-pen-to-square"
                                        @click="editStep(1)"
                                    ></i>
                                </div>
                            </div>
                            <div style="max-height: 300px; overflow-y: scroll">
                                <div
                                    class="course border-bottom border-gray row align-items-center py-2 mx-2"
                                    v-for="(item, index) in selectedCourse"
                                    :index="index"
                                    :key="item.test"
                                >
                                    <div class="course-ids col-2">
                                        <div class="course-id">
                                            {{ index + 1 }}
                                        </div>
                                    </div>
                                    <div class="course-info col-8 pe-0">
                                        <div class="row align-items-center">
                                            <div class="col-4 course-img p-1">
                                                <img
                                                    :src="item.image"
                                                    alt=""
                                                    class="img-fluid rounded-3"
                                                />
                                            </div>
                                            <div class="col-8 p-1">
                                                <div
                                                    class="course-description lh-1"
                                                >
                                                    {{ item.name }}
                                                </div>

                                                <!-- <div class="float-end text-primary">
                                            <i class="fa-solid fa-star"></i> 4.5
                                        </div> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="course-remove text-end col-2">
                                        <i
                                            class="fa-regular fa-trash-can text-primary fs-3"
                                            @click="trashCourse(index)"
                                        ></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <h5 class="text-dark fw-bold">
                        Nombre de la ruta
                        <a href=""
                            ><i
                                class="fa-regular fa-pen-to-square text-primary fs-3 ms-2"
                                @click.prevent="editStep(1)"
                            ></i
                        ></a>
                    </h5>
                    <p class="text-dark">
                        {{ this.updateClient.name }}
                    </p>
                    <br />
                    <h5 class="text-dark fw-bold">
                        Usuarios Inscritos:
                        {{
                            this.selectedStudents
                                ? this.selectedStudents.length
                                : 0
                        }}
                        <i
                            class="fa-regular fa-pen-to-square text-primary fs-3 ms-2"
                            @click.prevent="editStep(2)"
                        ></i>
                    </h5>

                    <div id="informacionImportante"></div>

                    <button
                        v-if="selectedCourse.length > 0"
                        id="agregar"
                        type="button"
                        @click="agregarRouteStudent"
                        class="btn btn-primary text-light py-2 px-4 my-4 rounded-8 fs-5 fw-bold"
                    >
                        Actualizar Ruta
                    </button>
                    <button
                        v-else
                        id="agregar"
                        type="button"
                        @click.prevent="editStep(1)"
                        class="btn btn-primary text-light py-2 px-4 my-4 rounded-8 fs-5 fw-bold"
                    >
                        Seleccionar curso
                    </button>
                </div>
            </div>
        </div>

        <!-- modal confirmar -->
        <div
            class="modal fade"
            id="confirmarInscribir"
            tabindex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="confirmarInscribirLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <div
                            class="text-center fs-4 text-dark lh-sm"
                            v-if="step == '1'"
                        >
                            Has agregado
                            <br />
                            <b
                                >{{
                                    this.selectedCourse.length
                                        ? this.selectedCourse.length
                                        : 0
                                }}
                                cursos</b
                            >
                            a la nueva
                            <br />
                            ruta: <b> {{ updateClient.name }}</b>
                        </div>

                        <div
                            class="text-center fs-4 text-dark lh-sm"
                            v-if="step == '2'"
                        >
                            Has agregado
                            <br />
                            <b
                                >{{
                                    this.selectedStudents
                                        ? this.selectedStudents.length
                                        : 0
                                }}
                                usuarios</b
                            >
                            a la nueva ruta : <b> {{ updateClient.name }}</b>
                        </div>
                    </div>
                    <div
                        class="modal-footer border-0 text-center d-flex justify-content-between"
                    >
                        <button
                            class="btn btn-inverted px-4"
                            data-bs-dismiss="modal"
                        >
                            Cancelar
                        </button>
                        <button
                            id="pasar"
                            class="btn btn-primary px-4"
                            data-bs-dismiss="modal"
                            @click="pasarStep()"
                        >
                            Continuar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Confirmación -->
        <button
            id="succesBtn"
            type="button"
            class="btn btn-primary invisible"
            data-bs-toggle="modal"
            data-bs-target="#succesModal"
        ></button>
        <button
            id="errorBtn"
            type="button"
            class="btn btn-primary invisible"
            data-bs-toggle="modal"
            data-bs-target="#errorModal"
        ></button>
        
        <div
            class="modal fade"
            id="succesModal"
            tabindex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="succesModalLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title" id="succesModalLabel">Crear</h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="modal-body text-center">
                        Se ha creado<br />la ruta correctamente.
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary text-light"
                            data-bs-dismiss="modal"
                        
                        >
                            Aceptar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            id="errorModal"
            tabindex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="errorModalLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title" id="errorModalLabel">Error</h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="modal-body text-center">
                        Hubo un error al crear la ruta, haz superado el limite de tu licencia o hubo un error en el sistema.
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary text-light"
                            data-bs-dismiss="modal"
                            @click="redirectTo()"
                        >
                            Aceptar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.course-id {
    background-color: #4000bc;
    border-radius: 50%;
    text-align: center;
    width: 30px;
    height: 30px;
    line-height: 2;
    font-weight: 600;
    color: white;
}

.course:last-of-type {
    border: 0 !important;
}

.maxheight100vh {
    max-height: 100vh;
    overflow-y: scroll;
}
</style>

<script>
import {
    assertBlockParent,
    assertNullLiteralTypeAnnotation,
} from "@babel/types";

export default {
    props: [
        "get",
        "headertab",
        "wptoken",
        "url",
        "urlc",
        "urlr",
        "essuperadmin",
        "redirect",
        "empresas",
        "urlgetpackages",
        "cantidadpermitidaxlicencia",
        "cantidadactualxcliente",
        "getcoursebyid",
        "update",
    ],
    data() {
        return {
            step: "1",
            crearRutas: false,
            headersTabs: this.headertab,
            desserts: [],
            listcourses: [],
            dessertsStudents: [],
            dessertsCourse: [],
            selectedCourse: [],
            parentsCategories: [],
            selectedStudents: [],
            GetCourseById: this.getcoursebyid,
            users: [],
            parentId: 0,
            edit: [],
            destroy: [],
            updateClient: { name: "", description: "", uuid: "", client_id: 0 },
            token: this.wptoken,
            courseName: [],
            categories: [],
            courseLists: [],
            catSelected: "",
            showChat: null,
            selectedChat: null,
            StudentName: null,
            empresaSelected: "",
            coursesPackagesOrOne: [],
            courseSelect: [],
            timeout: 0,
            mostrarPaginasCourses: false,
            paginaActualCourses: 0,
            ultimaPaginaCourses: -1
        };
    },
    mounted() {
        this.defaultCourseItems();
        this.getData();
        this.getDataCourse();
        this.getWordpressCourseCategory();
        this.getDataStudents();
        this.getUpdateData();
    },
    methods: {
        getUpdateData() {
            const updateData = this.update;
            let courses = [];
            let users = [];

            this.updateClient.name = updateData.name;
            this.updateClient.description = updateData.description;
            
            updateData.courses.forEach(function (data) {
                courses.push(data);
            });
            
            updateData.usuarios.forEach(function (data) {
                users.push(data);
            });
            console.log(updateData);
            this.empresaSelected = updateData.client_id;

            this.selectedCourse = courses;
            this.selectedStudents = users;
            this.updateClient.uuid = updateData.uuid;
            this.updateClient.client_id = updateData.client_id;
        },
        getWordpressCourseCategory() {
            let parentsCategory = [];
            axios.get("/search/category").then((res) => {
                this.categories = res.data;

                let arrayParent = [];
                var categoriesParent = this.categories.children;
                for (var k in categoriesParent){
                    if (categoriesParent.hasOwnProperty(k)) {
                        arrayParent.push(k);
                    }
                }

                this.parentsCategories = arrayParent;
            });
        },
        defaultCourseItems() {
            let defaultData = [];
            if (this.selectedCourse.length > 0) {
                defaultData = this.selectedCourse;
            }

            let newArray = [];
            if (localStorage.getItem("cursoDefecto")) {
                this.coursesPackagesOrOne = Array.isArray(JSON.parse( localStorage.getItem("cursoDefecto") )) ? 
                JSON.parse( localStorage.getItem("cursoDefecto") ).reverse() : 
                [JSON.parse( localStorage.getItem("cursoDefecto") )];
                this.coursesPackagesOrOne.forEach(function (data) {
                    newArray.push({
                        image: data.image,
                        name: data.name,
                        item: data.item,
                        slug: data.slug,
                        borrado: data.principal,
                    });
                });

                if (defaultData.length > 0) {
                    defaultData.forEach(function (data) {
                        newArray.push({
                            image: data.image,
                            name: data.name,
                            item: data.item,
                            slug: data.slug,
                            borrado: true,
                        });
                    });
                }

                localStorage.removeItem("cursoDefecto");
            }
            this.selectedCourse = newArray;
        },
        getData() {
            let url = this.url + "?withUsers=true&search=" + this.StudentName;
            if (this.empresaSelected) {
                url =
                    this.empresaSelected.users +
                    "?withUsers=true&search=" +
                    this.StudentName +
                    "&onlyByClient=true";
            }
            axios.get(url).then((res) => {
                this.desserts = res.data;
            });
        },
        async addCourseItems(image, name, id, slug, item) {
            this.courseSelect = item;
            var coursesCategories = item.categories;
            const parentsCategories = this.parentsCategories;
            let codeParentId = 0;
            for (var k in coursesCategories){
                if (coursesCategories.hasOwnProperty(k)) {
                    for (var j in coursesCategories[k]){
                        if (coursesCategories[k].hasOwnProperty(j)) {
                            if (j == 'id') {
                                if (parentsCategories.find(u => u == coursesCategories[k][j]) != undefined) {
                                    codeParentId = coursesCategories[k][j];
                                }
                            }
                        }
                    }
                }
            }
            this.parentId = codeParentId;

            const response = await this.openModalCourse(item);
            if (response) return;
            if (this.selectedCourse.length > 0) {
                if (this.selectedCourse.find((e) => e.item == id)) return;
                this.selectedCourse.push({
                    image: image,
                    name: name,
                    item: id,
                    slug: slug,
                    borrado: true,
                });
            } else {
                this.selectedCourse.push({
                    image: image,
                    name: name,
                    item: id,
                    slug: slug,
                    borrado: true,
                });
            }
        },
        editStep(stepOption) {
            this.step = stepOption;
        },
        trashCourse(item) {
            if (this.coursesPackagesOrOne.length !== 0) {
                let selectedCourse = this.selectedCourse;
                this.coursesPackagesOrOne.forEach(function (data) {
                    const datosEliminar = {
                        image: data.image,
                        name: data.name,
                        item: data.id,
                        slug: data.slug,
                        borrado: data.principal,
                    };
                    selectedCourse.splice(datosEliminar, 1);
                });
                this.selectedCourse = selectedCourse;
                this.coursesPackagesOrOne = [];
                return;
            }
            this.selectedCourse.splice(item, 1);
        },
        getDataCourse() {
            axios.get(this.urlc).then((res) => {
                this.dessertsCourse = res.data;
                if (res.data.length > 0) {
                    this.mostrarPaginasCourses = true;
                    this.paginaActualCourses = 1;
                }
            });
        },
        getCoursesByPage(page) {
            axios.get(this.urlc, {
                    params: {
                        search: this.courseName,
                        category: this.catSelected,
                        page: page
                    },
                }).then((res) => {
                this.dessertsCourse = res.data;
                if (res.data.length > 0) {
                    this.mostrarPaginasCourses = true;
                    this.paginaActualCourses = page;
                }
                if (res.data.length < 50) {
                    this.ultimaPaginaCourses = page;
                }
            });
        },
        filterDataCourse() {
            axios
                .get(this.urlc, {
                    params: {
                        search: this.courseName,
                        category: this.catSelected,
                    },
                })
                .then((res) => {
                    this.dessertsCourse = res.data;
                    this.ultimaPaginaCourses = -1;
                    if (res.data.length > 0) {
                        this.mostrarPaginasCourses = true;
                        this.paginaActualCourses = 1;
                    }
                    if (res.data.length < 50) {
                        this.ultimaPaginaCourses = 1;
                    }
                });
        },
        filterDataStudent() {
            let url = this.url + "?withUsers=true";
            if (this.empresaSelected) {
                url = url + "&onlyByClient=true&idClientSelect="+this.empresaSelected.idClient;
            }
            if (this.StudentName) {
                url = url + "&search=" + this.StudentName;
            }
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                console.log(url);
                axios.get(`${url}&onlyUsers=true`).then((res) => {
                    this.dessertsStudents = res.data;
                });
            }, 1000);

        },
        getDataStudents() {
            axios
                .get(this.url + "?withUsers=true&search=undefined&onlyUsers=true")
                .then((res) => {
                    this.dessertsStudents = res.data;
                });
        },
        editarCliente() {
            let btn = document.getElementById("update");
            let cancel = document.getElementById("cancel");
            let modal = document.getElementById("updateModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .put(this.url + "/" + this.edit.uuid, this.edit)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                    }, 500);
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        eliminarCliente() {
            const response = document.getElementById("response");
            let btn = document.getElementById("delete");
            let cancel = document.getElementById("close");
            let modal = document.getElementById("deleteModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .delete(this.url + "/" + this.destroy.uuid)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        btn.textContent = "Eliminar";
                    }, 500);
                })
                .catch((err) => {
                    response.outerText = "Error al eliminar datos";
                    cancel.removeAttribute("disabled");
                    btn.setAttribute("style", "display:none");

                    setTimeout(() => {
                        btn.removeAttribute("disabled");
                        btn.removeAttribute("style");
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        window.location.reload();
                    }, 1000);
                });
        },
        agregarRouteStudent() {
            if(!this.updateClient.name){
                this.$swal('Debe seleccionar un nombre de ruta de aprendizaje').then(e => {
                    this.editStep(1);
                })
                return;
            }

            if(this.selectedCourse.length == 0){
                this.$swal('Debe seleccionar cursos para la creación de la ruta').then(e => {
                    this.editStep(1);
                })
                return;
            }

            if (this.empresas.length > 0 && !this.empresaSelected) {

                let optSelect = ''
                this.empresas.forEach(e => {
                    optSelect += "<option value='"+e+"'>"+e.client+"</option>"
                })
                this.$swal({
                    title: "Debe seleccionar una empresa para continuar",
                    html: "<select class='form-control' name='select-empresa-sweet-alert' id='select-empresa-sweet-alert'>"+optSelect+"</select>",
                    confirmButtonText: "Seleccionar",
                }).then( res => {
                    this.empresaSelected = document.getElementById('select-empresa-sweet-alert').value;
                    console.log(this.empresaSelected);
                    this.agregarRouteStudent();
                }  );
                return
            }
            let btn = document.getElementById("agregar");
            let succesBtn = document.getElementById("succesBtn");
            let errorBtn = document.getElementById("errorBtn");
            btn.textContent = "Procesando ...";
            let students = [];

            this.selectedStudents.forEach((e) => {
                students.push(e);
            });

            this.updateClient.cursos = this.selectedCourse;
            this.updateClient.students = students;
            let url = this.urlr;
            if (this.empresaSelected) {
                url = this.empresaSelected.routes;
            }
            if (this.StudentName) {
                url = url + "&search=" + this.StudentName;
            }
            axios
                .post(this.urlr, { updateClient: this.updateClient, parent_id: this.parentId } )
                .then((res) => {
                    if (localStorage.getItem("cursoDefecto")) {
                        localStorage.removeItem("cursoDefecto");
                    }
                    this.updateClient = { name: "" };
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        succesBtn.click();
                        btn.removeAttribute("disabled");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                    }, 500);
                })
                .catch((error) => {
                    errorBtn.click();
                });
        },
        redirectTo() {
            window.location.href = this.redirect;
        },
        agregarCliente() {
            let btn = document.getElementById("agregar");
            btn.textContent = "Procesando ...";
            axios
                .post(this.url, this.updateClient)
                .then((res) => {
                    this.updateClient = { name: "" };
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        btn.removeAttribute("disabled");
                        this.getData();
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                    }, 500);
                })
                .catch((err) => {});
        },
        inscribirruta() {
            alert("--demo-- Ruta inscrita correctamente --demo--");
        },
        pasarStep(paso = null) {
            if (this.step == "1") this.step = "2";
            else if (this.step == "2") this.step = "3";

            if (paso == 3) this.step = "3";
        },
        changeUrl() {
            this.dessertsStudents = [];
            this.selectedStudents = [];
            this.filterDataStudent();
        },
        async openModalCourse(course) {
            let listCourses = [];
            document
                .getElementById("listadoCursosPaquetes")
                .classList.remove("d-block");
            document
                .getElementById("listadoCursosPaquetes")
                .classList.add("d-none");
            let modal = document.getElementById("addModal");
            this.destroy = course;
            this.seen = false;
            this.seen_two = false;
            this.viewMessage = false;
            this.listcourses = [];
            await axios
                .get(
                    this.urlgetpackages +
                        "?withUsers=true&idCourse=" +
                        this.destroy.id
                )
                .then((res) => {
                    let bd = document.getElementsByClassName("modal-backdrop");
                    if (res.status === 200) {
                        const data = res.data;
                        if (data == "") {
                            this.seen_two = true;
                            this.viewMessage = false;
                            document
                                .getElementById("listadoCursosPaquetes")
                                .classList.remove("d-block");
                            document
                                .getElementById("listadoCursosPaquetes")
                                .classList.add("d-none");
                            document
                                .getElementById("cirle-content")
                                .classList.remove("d-none");
                            document
                                .getElementById("cirle-content")
                                .classList.add("d-block");
                            document.body.removeChild(bd[0]);
                            modal.removeAttribute("style");
                            return;
                        }
                        this.viewMessage = true;
                        const url = this.GetCourseById;

                        data.forEach(async function (name) {
                            await axios
                                .get(url, {
                                    params: {
                                        search: name,
                                    },
                                })
                                .then((res) => {
                                    const dataResp = res.data;
                                    listCourses.push({
                                        image: dataResp.image,
                                        name: dataResp.name,
                                        item: dataResp.id,
                                        slug: dataResp.slug,
                                    });
                                });
                        });
                    }
                });

            if (this.viewMessage) {
                document
                    .getElementById("cirle-content")
                    .classList.remove("d-block");
                document
                    .getElementById("cirle-content")
                    .classList.add("d-none");
                document
                    .getElementById("listadoCursosPaquetes")
                    .classList.remove("d-none");
                document
                    .getElementById("listadoCursosPaquetes")
                    .classList.add("d-block");
                this.listcourses = listCourses;
                this.seenCourses = true;
                return true;
            }

            return false;
        },

        aceptarProceso() {
            let modal = document.getElementById("addModal");
            let bd = document.getElementsByClassName("modal-backdrop");

            if (localStorage.getItem("cursoDefecto")) {
                localStorage.removeItem("cursoDefecto");
            }
            this.courseSelect.principal = true;
            this.listcourses.push({
                image: this.courseSelect.image,
                name: this.courseSelect.name,
                item: this.courseSelect.id,
                slug: this.courseSelect.slug,
            });
            localStorage.setItem(
                "cursoDefecto",
                JSON.stringify(this.listcourses)
            );
            document.getElementById("ocultarData").classList.add("d-none");
            document.body.removeChild(bd[0]);
            modal.removeAttribute("style");
            document.getElementById("cirle-content").classList.remove("d-none");
            document.getElementById("cirle-content").classList.add("d-block");
            document
                .getElementById("listadoCursosPaquetes")
                .classList.remove("d-block");
            document
                .getElementById("listadoCursosPaquetes")
                .classList.add("d-none");
            this.defaultCourseItems();
        },
        cancelarProceso() {
            if (localStorage.getItem("cursoDefecto")) {
                localStorage.removeItem("cursoDefecto");
            }
            document
                .getElementById("listadoCursosPaquetes")
                .classList.remove("d-block");
            document
                .getElementById("listadoCursosPaquetes")
                .classList.add("d-none");
            document.getElementById("cirle-content").classList.remove("d-none");
            document.getElementById("cirle-content").classList.add("d-block");
        },
        revisarCursosExtra() {
            if (this.seenCourses) {
                document
                    .getElementById("ocultarData")
                    .classList.remove("d-none");
                document.getElementById("ocultarData").classList.add("d-block");
                document
                    .getElementById("listadoCursosPaquetes")
                    .classList.remove("d-none");
                document
                    .getElementById("listadoCursosPaquetes")
                    .classList.add("d-block");
                this.seen = false;
                return;
            }
        },
        checkEmpresaSelected() {
            if (!this.empresaSelected && this.essuperadmin == "true") {
                this.$swal("Debe seleccionar una empresa para continuar").then(
                    (res) => {
                        document.getElementById("empresa").focus();
                        this.userselected = [];
                    }
                );
            }
        },

        cancelar_cursos_extra() {
            this.courseSelect = [];
            localStorage.removeItem("cursoDefecto");
        },

        informacionGeneral() {
            const infoImportante = document.getElementById(
                "informacionImportante"
            );

            if (
                parseInt(this.cantidadactualxcliente) >=
                parseInt(this.cantidadpermitidaxlicencia)
            ) {
                infoImportante.innerHTML = `<h3>No puedes agregar más rutas, haz completado el limite de tu licencia permitida.</h4>`;
                return;
            }

            let totalXLicencia =
                parseInt(this.cantidadpermitidaxlicencia) -
                parseInt(this.cantidadactualxcliente) -
                1;
            this.crearRutas = true;

            if (totalXLicencia <= 0) {
                infoImportante.innerHTML = `<h4>Ha superado la cantidad de rutas permitidas por su licencia.</h4>`;
                return;
            }

            infoImportante.innerHTML = `<h4>Actualmente tiene ${this.cantidadactualxcliente} rutas, su licencia es de ${this.cantidadpermitidaxlicencia} rutas.</h3>
                                    Al crear la ruta, le quedarían ${totalXLicencia} de la licencia.</h4>`;
        },
        plusStep() {
            if (this.step == "1") {
                this.step = "2";
            } else {
                if (this.step == "2") {
                    this.step = "3";
                }
            }
        },
        lessStep() {
            if (this.step == "3") {
                this.step = "2";
            } else {
                if (this.step == "2") {
                    this.step = "1";
                }
            }
        },
        strippedContent(text) {
            let regex = /(<([^>]+)>)/ig;
            return text.replace(regex, "");
        }
    },
};
</script>
